import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { OPERATORS_REQUIRE_VALUE } from '../../../../../../../constants';
import { useEventAndVariableAccountOptions } from '../../../../../../../helpers/customHooks';
import FormRuleTableBase, { RuleTableContext } from '../FormRuleTableBase';
import { FormRuleTableContext } from './EditFormRuleTable';
import ImportExportTable from './ImportExportTable';
import TableBodyRows from './TableBodyRows';
import TableHeaderRow from './TableHeaderRow';

// Re-export as LookupTableContext so sub-components can import from this file unchanged
export const LookupTableContext = RuleTableContext;

const FormRuleTable = ({ stepsData, setStepsData, initialStepsData }) => {
     const { fetchRule } = useContext(FormRuleTableContext);
     const listCustomCategories = useSelector((state) => state.subscriber.customCategories);
     const { fetchLoading } = useEventAndVariableAccountOptions(true);

     const IsExisted = (id) => listCustomCategories.find((item) => item.id === id);
     const IsExistedWithName = (val) => listCustomCategories.find((item) => item.name === val);

     const validateFn = (tableRow) => {
          let errorColumn = { type: '', key: '' };
          tableRow.some((row) => {
               const flag = row.conditions.some((col) => {
                    const { type, value, key, operator } = col.g0;
                    if (value === '') {
                         if (type === 'Event' || OPERATORS_REQUIRE_VALUE.includes(operator)) {
                              errorColumn = { type, key };
                              return true;
                         }
                    }
                    return false;
               });
               return flag;
          });
          return errorColumn;
     };

     const onRevertSuccess = () => {
          fetchRule();
     };

     return (
          <FormRuleTableBase
               variant='rule-edit'
               stepsData={stepsData}
               setStepsData={setStepsData}
               initialStepsData={initialStepsData}
               rulesStateKey='formCategoriesRules'
               fetchLoading={fetchLoading}
               validateFn={validateFn}
               onRevertSuccess={onRevertSuccess}
               TableHeaderRow={TableHeaderRow}
               TableBodyRows={TableBodyRows}
               ImportExportTable={ImportExportTable}
               extraBodyContext={{ listCustomCategories }}
               extraImportContext={{ IsExisted, IsExistedWithName }}
               btnSaveStatusInitial={isEqual(stepsData, initialStepsData)}
          />
     );
};

FormRuleTable.propTypes = {
     stepsData: PropTypes.object,
     initialStepsData: PropTypes.object,
     setStepsData: PropTypes.func,
};

export default FormRuleTable;
